package top.wcpe.allincore.ui.runtime.element

import kotlin.jvm.JvmStatic

/**
 * 独立模型预览元素：保存平台模型资源、声明基准目录与运行时稳定实例键。
 *
 * 实例键仅由运行时结构路径与数据键生成，不接受作者属性覆盖。
 */
class ModelPreview private constructor() : UIElement<ModelPreview>() {

    private var sourceValue = ""
    private var modelBaseValue = ""
    private var textureValue: String? = null
    private var instanceKeyValue = ModelPreviewInstanceKeys.EMPTY
    private var scaleValue = DEFAULT_SCALE
    private var rotationXValue = DEFAULT_ROTATION
    private var rotationYValue = DEFAULT_ROTATION
    private var interactiveValue = true
    private var backgroundColorValue = 0

    protected override fun self(): ModelPreview = this

    fun source(value: String?): ModelPreview {
        sourceValue = value.orEmpty()
        return this
    }

    fun source(): String = sourceValue

    fun texture(value: String?): ModelPreview {
        textureValue = value
        return this
    }

    fun texture(): String? = textureValue

    fun modelBase(): String = modelBaseValue

    fun instanceKey(): String = instanceKeyValue

    internal fun runtimeMetadata(modelBase: String, nodePath: String, dynamicKey: String): ModelPreview {
        modelBaseValue = modelBase
        instanceKeyValue = ModelPreviewInstanceKeys.encode(nodePath, dynamicKey)
        return this
    }

    fun scale(value: Float): ModelPreview {
        scaleValue = if (!value.isFinite() || value <= 0f) DEFAULT_SCALE else value
        return this
    }

    fun scale(): Float = scaleValue

    fun rotationX(value: Float): ModelPreview {
        rotationXValue = if (value.isFinite()) value else DEFAULT_ROTATION
        return this
    }

    fun rotationX(): Float = rotationXValue

    fun rotationY(value: Float): ModelPreview {
        rotationYValue = if (value.isFinite()) value else DEFAULT_ROTATION
        return this
    }

    fun rotationY(): Float = rotationYValue

    fun interactive(value: Boolean): ModelPreview {
        interactiveValue = value
        return this
    }

    fun interactive(): Boolean = interactiveValue

    fun backgroundColor(value: Int): ModelPreview {
        backgroundColorValue = value
        return this
    }

    fun backgroundColor(): Int = backgroundColorValue

    companion object {
        private const val DEFAULT_SCALE = 1f
        private const val DEFAULT_ROTATION = 0f

        @JvmStatic
        fun create(): ModelPreview = ModelPreview()
    }
}
